import { useEffect, useRef, type FC, type PropsWithChildren } from "react";
import { useSetAtom } from "jotai";
import { stepListContainerAtom } from "@/routes/automations/automation-details-page/state";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { ScrollArea } from "@/components/flexkit/ScrollArea";

export const StepListContainer: FC<PropsWithChildren<PropsWithClassName>> = ({ className, children }) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const setStepListContainer = useSetAtom(stepListContainerAtom);

    useEffect(() => {
        setStepListContainer(contentRef.current);
    }, [setStepListContainer]);

    return (
        <ScrollArea
            autoScroll={true}
            autoScrollContentRef={contentRef}
            orientation="vertical"
            className={cn(
                "flex grow flex-col rounded-lg border border-border-subtle bg-[image:radial-gradient(circle,rgb(var(--border-subtle)/var(--border-subtle-opacity))_1.5px,transparent_1.5px)] bg-[length:15px_15px]",
                className,
            )}
        >
            <div
                ref={contentRef}
                data-automation-edit-container
                className={"relative flex grow items-start justify-center px-6 py-6"}
            >
                {children}
            </div>
        </ScrollArea>
    );
};
